// @flow


import type {AuthStateChangedEvent} from '../channels/onAuthStateChanged'

import {
  call,
  put,
  take,
} from 'redux-saga/effects'
import {sessionChannels} from '../channels'
import {sessionActions} from '../actions'

export function* onAuthStateChangedEffect(): Effect {
  const ch = yield call(sessionChannels.onAuthStateChanged)
  while (true) {
    const event: AuthStateChangedEvent = yield take(ch)
    if (event.user) {
      const user = event.user
      const idToken: string = yield call([user, user.getIdToken])
      yield put(sessionActions.setUser(event.user, idToken))
    }
    yield put(sessionActions.setReady())
  }

}
